import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON     from 'utilities/serialize_json';
class Form extends BaseAjaxForm {
  validFunction = validations.delivery_option;
  submitFunction = save;
  protected setValidations(){
  }
}

riot.mixin('forms.delivery_options.save', Form as riot.TagMixin)
